import { Column } from '../../../coaching-observation/experimental.grid';
import { ColumnContext, ColumnType } from '../coaching-coverage-grid.model';

export function togglePeriodColumns(
    columns: Array<Column<ColumnContext>>,
    maxShown: number,
): void {
    const cols = columns.filter((e) =>
        e.id.startsWith(ColumnType.PERIOD.toString()),
    );
    // eslint-disable-next-line no-return-assign
    cols.forEach((e) => (e.hidden = true));
    // eslint-disable-next-line no-return-assign
    cols.slice(0, maxShown).forEach((e) => (e.hidden = false));
}
